import React, { useState, useEffect } from "react";
import { Box, Heading, Text, Button, VStack, Image, Container, SimpleGrid, useColorMode, useColorModeValue } from "@chakra-ui/react";
import { BsCashCoin } from "react-icons/bs";
import { PiSolarPanelLight } from "react-icons/pi";
import { GoTools } from "react-icons/go";
import Lottie from "react-lottie";
import animationGreen from "../assets/animations/arrow-animation.json";
import animationOrange from "../assets/animations/arrow-animation-orange.json";

// Assuming you have these images in your project
const projectImages = [
  require("../assets/images/satoal-showcase1.jpeg"),
  require("../assets/images/satoal-showcase2.jpeg"),
  require("../assets/images/satoal-showcase3.jpeg"),
  require("../assets/images/satoal-showcase4.jpeg"),
];

function ImageCarousel({ images }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 2000); // Change image every 2 seconds
    return () => clearInterval(intervalId);
  }, [images.length]);

  return (
    <Box position="relative" width="100%" height="400px" overflow="hidden" borderRadius="md">
      {images.map((image, index) => (
        <Image
          key={index}
          src={image}
          alt={`Project Image ${index + 1}`}
          objectFit="cover"
          width="100%"
          height="100%"
          position="absolute"
          top="0"
          left="0"
          opacity={index === currentImageIndex ? 1 : 0}
          transition="opacity 1s ease-in-out"
          zIndex={index === currentImageIndex ? 1 : 0}
        />
      ))}
    </Box>
  );
}

function Home() {
  const { colorMode } = useColorMode();
  const heroBgColor = useColorModeValue("brand.cream", "brand.navy");
  const heroHeadingColor = useColorModeValue("brand.navy", "brand.orange");
  const heroTextColor = useColorModeValue("brand.dark", "brand.cream");
  const featuresBgColor = useColorModeValue("brand.green", "brand.dark");
  const featureItemBgColor = useColorModeValue("brand.cream", "brand.navy");
  const featureHeadingColor = useColorModeValue("brand.dark", colorMode === "light" ? "brand.green" : "brand.orange");
  const featureTextColor = useColorModeValue("brand.dark", "brand.cream");

  const features = [
    { title: "Eco-Friendly", description: "By choosing SATOAL®, you choose a friend committed to your success and the future of renewable energy.", icon: <PiSolarPanelLight size={32} /> },
    { title: "Cost-Effective", description: "Reduce your energy bill by up to 99% and eliminate concerns about future rate increases.", icon: <BsCashCoin size={32} /> },
    { title: "Expert Installation", description: "We guarantee exceptional quality and safety in our installations, all completed by certified professionals with social security coverage. ", icon: <GoTools size={32} /> },
  ];

  return (
    <Box>
      {/* Hero Section */}
      <Box bg={heroBgColor} py={20}>
        <Container maxW={"container.xl"}>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
            <VStack spacing={5} align={"flex-start"}>
              <Heading as="h1" size="2xl" color={heroHeadingColor}>
                Harness the Power of the Sun with Satoal
              </Heading>
              <Text fontSize={"xl"} color={heroTextColor}>
                We Deliver Innovative Energy Solutions with Precision, Passion, and Expertise.
              </Text>
              <Button colorScheme="brand" size="lg" onClick={() => window.open("https://wa.me/34672542946", "_blank")}>
                Get a Free Quote
              </Button>
              <Lottie options={{ animationData: colorMode === "dark" ? animationOrange : animationGreen }} height={{ base: 100, md: 200 }} width={{ base: 100, md: 200 }} />
            </VStack>
            <Box>
              <ImageCarousel images={projectImages} />
            </Box>
          </SimpleGrid>
        </Container>
      </Box>

      {/* Features Section */}
      <Box py={20} bg={featuresBgColor}>
        <Container maxW={"container.xl"}>
          <Heading as="h2" size="xl" mb={10} textAlign="center" color="brand.cream">
            Why Choose Satoal?
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
            {features.map((feature, index) => (
              <VStack key={index} align={"center"} bg={featureItemBgColor} p={5} borderRadius="md">
                {feature.icon}
                <Heading as="h3" size="md" color={featureHeadingColor}>
                  {feature.title}
                </Heading>
                <Text textAlign="center" color={featureTextColor}>
                  {feature.description}
                </Text>
              </VStack>
            ))}
          </SimpleGrid>
        </Container>
      </Box>
      {/* <Box py={10}>
        <Container maxW={"container.xl"}></Container>
      </Box> */}
      {/* <Box py={10}>
          <Container maxW={"container.xl"}>
          <Heading as="h2" size="xl" mb={10} textAlign="center" color={featureHeadingColor}>
          Our Clients and Collaborations
          </Heading>
            <SimpleGrid columns={{ base: 3, md: 5 }} spacing={10}>
              <Image src={require("../assets/images/ALDI.jpg")} alt="ALDI logo"  boxSize="100px" objectFit={"contain"}/>
              <Image src={require("../assets/images/Bosh.jpg")} alt="Bosch logo" boxSize="100px" objectFit={"contain"} />
              <Image src={require("../assets/images/Centroplan.jpg")} alt="Centroplan logo" boxSize="100px" objectFit={"contain"}/>
              <Image src={require("../assets/images/Desjardins.jpg")} alt="Desjardins logo" boxSize="100px" objectFit={"contain"}/>
              <Image src={require("../assets/images/Facom.jpg")} alt="Facom logo" boxSize="100px" objectFit={"contain"}/>
              <Image src={require("../assets/images/Leister.jpg")} alt="Leister logo" boxSize="100px" objectFit={"contain"}/>
              <Image src={require("../assets/images/LIDL.jpg")} alt="LIDL logo" boxSize="100px" objectFit={"contain"}/>
              <Image src={require("../assets/images/Sika.jpg")} alt="Sika logo" boxSize="100px" objectFit={"contain"}/>
              <Image src={require("../assets/images/Volkswagen.jpg")} alt="Volkswagen logo" boxSize="100px" objectFit={"contain"}/>
            </SimpleGrid>
          </Container>
        </Box> */}
    </Box>
  );
}

export default Home;
